<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import '@/assets/style/style.css'

export default {
  name: 'app'
}
</script>

<style>
#app {
  display: flex;
  position: relative;
  height: 100%;
  overflow: hidden;
  background: repeating-linear-gradient(
      45deg,
      transparent,
      transparent 10px,
      #222 10px,
      #222 20px
    )
    #282828;
}
</style>
